const contactPage = init => store => {
  store.on('@init', () => ({ contactPage: init}));
  store.on('contactPage/success', (state, data) => ({ contactPage: data}));
};

export default contactPage;
